<template>
    <div id="cta-cover">
        <img class="cta-cover-bg" :src="coverBgSrc" alt="" />
        <div id="cta-cover-text">
            <survey-title class="cta-cover-title">Communication<br />Tendencies<br />Assessment</survey-title>
            <span v-if="badge" class="cta-cover-badge">{{ badge }}</span>
            <survey-subtitle>{{ reportType }}</survey-subtitle>
            <survey-subtitle>{{ firstName }} {{ lastName }}</survey-subtitle>
            <survey-subtitle>{{ $t(`reportsWeb.DATE_COMPLETED`, { date }) }}</survey-subtitle>
        </div>
        <img class="cta-logo" src="/images/design/cta/logo.svg" alt="cta logo" />
    </div>
</template>
<script src="./CoverPage.ts"></script>
<style lang="scss">
body.rendering {
    #cta-cover {
        height: 1040px;
    }
}

#cta-cover {
    position: relative;
    left: -5%;
    width: 110%;
    height: 1278px;
    border-radius: 2rem;
    padding: 5rem;
    overflow: hidden;

    .cta-cover-bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        border-radius: 2rem;
    }

    .cta-logo {
        position: absolute;
        bottom: 5rem;
        left: 5rem;
        width: 24%;
        height: 6%;
    }

    .cta-cover-badge {
        display: inline-block;
        margin: 0.25rem 0 1rem;
        padding: 0.35rem 1rem;
        border-radius: 0.25rem;
        background: rgba(85, 170, 156, 1);
        color: white;
        font-size: 0.7rem;
        font-weight: 700;
        letter-spacing: 0.12em;
    }
}

#cta-cover-text {
    position: relative;
    padding-left: 2em;

    .survey-subtitle {
        color: rgba(85, 170, 156, 1);
    }
}

.cta-cover-title {
    font-size: 4rem !important;
    line-height: 5rem !important;
}
</style>
